module.exports = __webpack_public_path__ + "img/img99.98eeb13f.jpg";